// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ViewTermsAndConditions_contentWrapper_2C5ST","noFooter":"ViewTermsAndConditions_noFooter_2nhBL","editBtn":"ViewTermsAndConditions_editBtn_2_W1o"};